import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {SpinnerButton} from "../../SpinnerButton";
import { withTranslation } from 'react-i18next';

class AddWooCommerceStoreFormClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            storeUrl: '',
            consumerKey: '',
            consumerSecret: '',
            loading: false,
            error: null,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        const { t } = this.props;
        const storeUrl = this.state.storeUrl.trim();
        const consumerKey = this.state.consumerKey.trim();
        const consumerSecret = this.state.consumerSecret.trim();

        if (!storeUrl) {
            this.setState({ error: t('woocommerce.store_url_required') });
            return;
        }

        if (!consumerKey) {
            this.setState({ error: t('woocommerce.consumer_key_required') });
            return;
        }

        if (!consumerSecret) {
            this.setState({ error: t('woocommerce.consumer_secret_required') });
            return;
        }

        this.setState({ loading: true, error: null });

        new APIClient(API_URL + 'get_access_tokens/woocommerce/').call('POST', {
            store_url: storeUrl,
            consumer_key: consumerKey,
            consumer_secret: consumerSecret,
        }).then((response) => {
            if (response.status === 'ERROR') {
                this.setState({ loading: false, error: response.error_message });
            } else {
                this.setState({ loading: false });
                this.props.afterSuccessfulSubmit(response.data);
            }
        }).catch(() => {
            this.setState({
                loading: false,
                error: t('woocommerce.connection_error'),
            });
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <ModalBody>
                    <div className="modal-section">
                        <p>{t('woocommerce.connect_description')}</p>
                        <div className="form-row">
                            <label>{t('woocommerce.store_url_label')}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t('woocommerce.store_url_placeholder')}
                                value={this.state.storeUrl}
                                onChange={(e) => this.setState({ storeUrl: e.target.value, error: null })}
                            />
                        </div>
                        <div className="form-row">
                            <label>{t('woocommerce.consumer_key_label')}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t('woocommerce.consumer_key_placeholder')}
                                value={this.state.consumerKey}
                                onChange={(e) => this.setState({ consumerKey: e.target.value, error: null })}
                            />
                        </div>
                        <div className="form-row">
                            <label>{t('woocommerce.consumer_secret_label')}</label>
                            <input
                                type="password"
                                className="form-control"
                                placeholder={t('woocommerce.consumer_secret_placeholder')}
                                value={this.state.consumerSecret}
                                onChange={(e) => this.setState({ consumerSecret: e.target.value, error: null })}
                            />
                        </div>
                        <div className="alert alert-info" style={{ fontSize: '0.9em', marginTop: '1em', marginBottom: 0 }}>
                            {t('woocommerce.api_help_link')}
                        </div>
                        {this.state.error && (
                            <div className="alert alert-danger" style={{ fontSize: '0.9em', marginTop: '1em', marginBottom: 0 }}>
                                {this.state.error}
                            </div>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.state.loading ? (
                        <SpinnerButton />
                    ) : (
                        <button
                            className="btn -alt"
                            onClick={this.handleSubmit}
                        >
                            {t('woocommerce.connect_button')}
                        </button>
                    )}
                </ModalFooter>
            </div>
        );
    }
}

export const AddWooCommerceStoreForm = withTranslation()(AddWooCommerceStoreFormClass);
